import React from 'react';
import PropTypes from 'prop-types';

import './form-page.scss';

const FormSection = props => {
  const { children, label, description, isShowing = true } = props;

  if (!isShowing) {
    return null;
  }

  return (
    <div className="form-section">
      {(label || description) && (
        <div className="section-label">
          <div className="label">{label}</div>
          <div className="description">{description}</div>
        </div>
      )}
      <div className="section-inputs">{children}</div>
    </div>
  );
};

FormSection.propTypes = {};

FormSection.defaultProps = {};

export default FormSection;
